import { driver , driverAPK} from "@/utils/constants";
import { handleResponse, handleError } from "@/utils/functions";

export default (axios) => ({
  getDriverOptions(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(driver.options, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDriverList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(driver.base, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDriverView(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${driver.base}${id}/view/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDriverObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${driver.base}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  createDriverObject(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${driver.base}`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateDriverObject(payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${driver.base}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  partiallyUpdateDriverObject(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${driver.base}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDriverSelectList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(driver.select, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDriverDocuments(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(driver.document, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  downloadDriverSheet(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${driver.base}download_sheet/`, {
          params: params,
          headers: {
            Accept: "application/xlsx",
          },
          responseType: "blob",
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  deleteDriverZones(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${driver.deleteZonesDriver}delete_assigned_zone/`, {
          data: {
            id: id,
          },
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  deleteDocument(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${driver.document}${id}`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateDriverStatus(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${driver.base}${id}/update_driver_status/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDriverAppDownload() {
    return new Promise((resolve, reject) => {
      axios
        .get(driverAPK.base)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
